// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCeQgHIMeGFY1sJOEVicVSnuVftkgMhakk",
  authDomain: "dog-registry-1fcde.firebaseapp.com",
  projectId: "dog-registry-1fcde",
  storageBucket: "dog-registry-1fcde.firebasestorage.app",
  messagingSenderId: "609838470861",
  appId: "1:609838470861:web:b25b517ccccacbc53afb84",
  measurementId: "G-TXJ32N17HK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, analytics, db, auth, storage };
